import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit, Output, inject, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-view-cameras',
  templateUrl: './view-cameras.component.html',
  styleUrls: ['./view-cameras.component.scss'],
})
export class ViewCamerasComponent {
  private modalController = inject(ModalController);
  
  @Input() videoStreamProvider;
  @Input() isSelectable: boolean;
  @Output() removeFacility: EventEmitter<Boolean> = new EventEmitter();

  constructor() { }

  async selectCamera(ev) {
    this.modalController.dismiss(ev.detail.value);
  }

  async removeFacilityFn() {
    this.removeFacility.emit(true)
  }

  close() {
    this.modalController.dismiss();
  }
}
